/**
 * Variables of the CMS queries (`getContent(id, {variables, fallbackVariables})`) and the query parameters built
 * from them. No aliased imports: also used by the SSR middleware (`server/middlewares/reactRenderer/urls.ts`).
 */

/** Value of a query variable: scalars, lists and nested objects (`slug: {it: ['/a', '/a/']}`, `fields: {…}`). */
export type TCmsQueryValue = string | number | boolean | null | undefined | TCmsQueryValue[] | TCmsQueryVariables;

/** Variables of a CMS query, or the flat query parameters built from them. */
export type TCmsQueryVariables = {[key: string]: TCmsQueryValue};

/** A nested object of variables (not a list). */
export const isCmsQueryObject = (value: TCmsQueryValue): value is TCmsQueryVariables =>
	typeof value === 'object' && value !== null && !Array.isArray(value);
